/*
Floating label
Label in placed inside the input (like a placeholder), but moves to the top of the input when value is added
based on https://codepen.io/steamforge/pen/NBqMYj
*/
class FloatingLabel {
  constructor(el) {

    this._bindEvents(el);
  }

  // add active an focus class
  _handleFocus (event) {
    const target = event.target;
    target.parentNode.classList.add('focus');
    target.parentNode.classList.add('active');
  }

  // remove active  and focus class
  _handleBlur(event) {
    const target = event.target;
    target.parentNode.classList.remove('focus');
    if(!target.value) {
      target.parentNode.classList.remove('active');
    }
  }

  // add active class
  _handleSelectChange (event) {
    const target = event.target;
    target.parentNode.parentNode.classList.add('active');
  }

  // register events
  _bindEvents(element) {

    const floatField = element.querySelector('input') || element.querySelector('textarea');
    const floatSelect = element.querySelector('select');

    if(floatField) {
      if (floatField.value) {
        element.classList.add('active');
      }

      floatField.addEventListener('focus', this._handleFocus);
      floatField.addEventListener('blur', this._handleBlur);
    } else if(floatSelect) {
      //is has selection, add class active
      if(floatSelect.selectedIndex > 0) {
        element.classList.add('active');
      }
      floatSelect.addEventListener("change", this._handleSelectChange);

    }
  }

}
// get DOM elements
function init () {
  const floatContainers = Array.from(document.querySelectorAll('.floating-label'));

  floatContainers.forEach((element) => {
    new FloatingLabel(element);
  });
}

module.exports = {
  init
};
